module.exports = new __parcel__URL__("news01.402c0439.jpg").toString();